<template>
	<paginator
		v-model="pageIndex"
		:nr-records="nrRecords"
		:page-size="pageSize"
		:page-set-size="10"
		:options="options"
		:disabled="disabled"
		@paginate="paginate"></paginator>
</template>

<script>
	import paginator from '../common/Paginator.vue';

	export default {
		name: 'BlogSearchPaginator',
		components: {
			paginator
		},
		emits: ['paginate'],
		props: {
			initialPageIndex: { type: Number, required: true },
			pageSize: { type: Number, required: true },
			nrRecords: { type: Number, required: true }
		},
		data() {
			return {
				pageIndex: this.initialPageIndex,
				disabled: false,
				options: {
					texts: {
						countMultiPage: 'Showing {from} to {to} of {count} matching blog posts.',
						countSinglePage: '{count} matching blog posts.',
						countSingleItem: '1 matching blog post.'
					}
				}
			};
		},
		methods: {
			paginate(pageIndex) {
				if (!this.disabled) {
					this.$emit('paginate', pageIndex);
				}
			},
			setDisabled(disabled) {
				this.disabled = disabled;
			},
			setPageIndex(pageIndex) {
				this.pageIndex = pageIndex;
			}
		}
	};
</script>
